
const isBrowser = () => typeof window !== "undefined";

let matches =
  isBrowser() &&
  typeof window !== "undefined" &&
  window.matchMedia("(min-width: 990px)").matches;

export const styles = (theme) => ({
  // GridsMarginTopAndPaddingAndPadding: {
  //     marginTop: '10vh',
  //     paddingLeft: '15vw',
  //     paddingRight: '15vw'
  // },

  //Global
  // centeredText: {
  //   textAlign: "center",
  //   marginTop: "20px",
  //   fontSize: "18px",
  // },

  fixedHeight20: {
    height: "20px",
  },

  customInputLabel: {
    "& legend": {
      visibility: "visible",
    },
  },

  //HOme

  HomePageContainer: {
    position: "relative",
    top: "80px",
  },
  HomePageContainerMobile: {
    position: "relative",
    top: "60px",
  },
  height100: {
    height: "100%",
    alignItems: "stretch",
  },
  inputRootQuartier: {
    height: "30px",
    // minHeight: "30px",
    // maxHeight: "30px",
    borderRadius: "2px !important",
    paddingTop: "1px !important",
    paddingBottom: "1px !important",
  },
  inputRootTFQuartierNone: {
    height: "100%",
    display: "none",
    paddingBottom: "0px !important",
  },
  inputRootTFQuartier: {
    height: "0%",
    display: "block",
    borderRadius: "0 !important",
    caretColor: "transparent !important",
    padding: "0px 0px !important",
  },
  inputRootACQuartier: {
    height: "100%",
  },

  autoCompleteCommuneInput: {
    padding: "0 !important",
  },
  autoCompletePoppper: {
    zIndex: 50,
  },
  testGrids: {
    marginTop: "10vh",
  },
  testGrids2: {
    marginTop: "10vh",
    paddingLeft: "15vw",
    paddingRight: "15vw",
  },
  drawerMenuMobile: {
    // backgroundColor: "#102665",
    height: "100vh",
    overflow: "hidden",
  },
  // GLOBAL
  fullHeight: {
    height: "100%",
  },
  listingAgenceVenteRecenteContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    borderLeft: "1px solid #d3d3d385",
    marginTop: "10px",
    marginBottom: "10px",
    paddingLeft: "5%",
  },
  // NAVBAR
  NavBarDesktopLink: {
    textAlign: "center",
  },
  NavbarDesktopRoot: {
    backgroundColor: "white",
    height: "80px",
    width: "100vw",
    // maxWidth: "100vw",
  },
  NavBarButtonsContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  NavbarMobileRoot: {
    backgroundColor: "white",
    height: "60px",
    width: "100%",
  },

  // Carte des PRIX
  formControl: {
    // margin: theme.spacing(1),
    minWidth: 120,
  },
  // selectEmpty: {
  //   // marginTop: theme.spacing(2),
  // },
  icon: {
    left: 0,
  },
  iconOpen: {
    transform: "none",
  },
  formControlLabel: {
    left: 24,
  },
  selectSelect: {
    paddingLeft: "24px",
  },
  ObtenirLePrixItemContainer: {
    borderRadius: "0.2666666667rem",
    boxShadow: "0 1px 2px 0",
    backgroundColor: "#fff",
    border: "none",
    padding: "1.6rem",
    marginTop: "1rem",
    marginBottom: "0.5rem",
  },
  InfoCarteDesPrixContainerDesktop: {
    height: "calc(100vh - 80px - 60px)",
    maxHeight: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 80px - 60px)`,
    overflow: "hidden",
  },
  InfoCarteDesPrixContainerMobile: {
    height: "calc(100vh - 80px - 60px)",
    maxHeight: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 80px - 60px)`,
    overflow: "scroll",
  },
  CDPSearchBarContainer: {
    height: "60px",
    backgroundColor: "white",
  },
  CarteDesPrixLayerFilterDesktopContainer: {
    height: "80px",
  },
  CarteDesPrixDesktopContainer: {
    height: `calc(100vh - 80px - 60px - 80px)`,
  },
  FilterCheckboxes: {
    marginLeft: "3vw",
    marginRight: "3vw",
    borderColor: "gray",
    borderStyle: "solid",
    borderTopWidth: "0px",
    borderLeftWidth: "0px",
    borderRightWidth: "0px",
    borderWidth: "1px",
    height: "5vh",
  },

  CDPFullElementGrid: {
    borderBottomColor: "Black",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    minHeight: "48px",
    padding: "10px",
    marginLeft: matches ? "20px" : "5px",
    marginRight: matches ? "20px" : "5px",
    fontSize: "0.9333333333rem",
  },

  CDPFullElementGridMobile: {
    borderBottomColor: "Black",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    minHeight: "48px",
    padding: "10px",
    marginLeft: matches ? "20px" : "5px",
    marginRight: matches ? "20px" : "5px",
    fontSize: "13px",
  },

  CDPElementGrid: {
    textAlign: "center",
    // fontWeight: "600",
  },

  CDPMainElementGrid: {
    textAlign: "left",
    // fontWeight: "600",
  },

  CDPSubFullElementGrid: {
    borderBottomColor: "darkgray",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    height: "40px",
    paddingLeft: "10px",
    marginLeft: matches ? "20px" : "5px",
    marginRight: matches ? "20px" : "5px",
    fontSize: "0.9333333333rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  CDPSubFullElementGridMobile: {
    borderBottomColor: "darkgray",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    height: "48px",
    padding: "10px",
    marginLeft: matches ? "20px" : "5px",
    marginRight: matches ? "20px" : "5px",
    fontSize: "13px",
  },

  CDPSubMainElementGrid: {
    color: "#00B4FF",
    textAlign: "left",
  },

  CDPSubElementGrid: {
    textAlign: "center",
  },

  CDPSqueletonGrid: {
    borderBottomColor: "darkgray",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    textAlign: "center",
    height: "40px",
    padding: "10px",
  },

  // height : 'calc(100vh - NAVBAR HEIGHT  - SEARCH BAR HEIGHT -LAYER FILTER HEIGHT)'

  CarteDesPrixMobileContainerNoPrices: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 60px - 60px - 40px)`,
  },
  CarteDesPrixMobileContainerWithPrices: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 60px - 60px - 100px - 45px)`,
  },

  CarteDesPrixMobileContainerNoPricesNoIphone: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 60px - 100px - 40px)`,
  },
  CarteDesPrixMobileContainerWithPricesNoIphone: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 100px - 60px - 100px - 45px)`,
  },
  // height : 'calc(100vh - NAVBAR HEIGHT  - SEARCH BAR HEIGHT -PRICEBARCOLORS HEIGHT)'

  CarteDesPrixMobileContainerWithPricesIphoneScroll: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 100px - 60px - 60px - 45px)`,
  },

  CarteDesPrixMobileContainerNoPricesIphoneScroll: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 60px - 60px - 40px)`,
  },

  // height : 'calc(100vh - NAVBAR HEIGHT  - SEARCH BAR HEIGHT -PRICEBARCOLORS HEIGHT)'

  MobileFilterCarteDesPrixDialogContainer: {
    backgroundColor: "white",
  },
  // MobileFilterCarteDesPrixDialogContainerFixed: {
  //   backgroundColor: "white",
  //   position: "fixed",
  //   width: "100%",
  // },
  // height : 'calc(${fullVirtualHeight}px  - NAVBAR HEIGHT  - SEARCH BAR HEIGHT -PRICEBARCOLORS HEIGHT - BOTTOMBARHEIGHT)'
  PrixImmobilierPageContainer: {
    top: "80px",
    position: "relative",
    height: `calc(100vh  - 80px)`,
    overflow: "hidden",
  },
  PrixImmobilierPageMobileContainer: {
    top: "60px",
    marginTop: "60px",
    position: "relative",
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 60px)`,
    overflow: "hidden",
  },
  PrixImmobilierPageMobileContainerWithPrices: {
    top: "60px",
    position: "relative",
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 60px - 125px)`,
    overflow: "hidden",
  },
  InfoPrixImmobilierMobileContainer: {
    height: "60px",
  },

  // ESTIMATION
  EstimationEtapesContainer: {
    // paddingTop: "20px",
    // paddingLeft: "20px",
  },
  EstimationEtapesItems: {
    paddingLeft: "12%",
    // paddingTop: "2%",
    paddingRight: "5%",
    overflow: "scroll",
    height: "calc(100vh - 80px - 64px)",
    paddingTop: "3.2rem",
    overflowX: "hidden",
  },

  EstimationEtapesItemsLogin: {
    paddingLeft: "12%",
    overflow: "scroll",
    paddingRight: "5%",
    // overflow: 'scroll',
    height: "calc(100vh - 80px - 64px)",
    paddingTop: "3.2rem",
  },
  EstimationEtapeResultatMobileContainer: {
    padding: "20px",
  },
  EstimationEtapesContainermobile: {
    paddingTop: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  EstimationPageContainer: {
    top: "80px",
    position: "relative",
    height: "calc(100vh - 80px)",
    overflow: "hidden",
    // height: `calc(100vh  - 80px)`,
    // overflow: "hidden",
  },

  EstimationDisplayResultsScrollerDesktop: {
    height: "calc(100vh - 100px)",
    overflow: "scroll",
  },
  EstimationPageContainerResults: {
    top: "65px",
    position: "relative",
    height: "calc(100vh - 65px)",
    overflow: "hidden",
  },
  EstimationPageContainerMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 50px - 60px)`,
    width: "auto",
    overflow: "scroll",
    top: "60px",

    position: "relative",
  },
  EstimationPageContainerMobileResults: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px)`,
    width: "auto",
    overflow: "scroll",
    top: "60px",

    position: "relative",
  },
  estimationMapContainer: {
    height: `calc(100vh  - 80px)`,
  },
  EstimationMapMobilePRO: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 60px - 193px - 100px)`,
    // height: `calc(${fullVirtualHeight}px  - TAILLE DE LA NAVBAR - TAILLE DU TEXTE - TAILLE DE LA BOTTOM BAR)`,
  },
  EstimationMapMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px  - 60px - 109px - 50px)`,
    // height: `calc(${fullVirtualHeight}px  - TAILLE DE LA NAVBAR - TAILLE DU TEXTE - TAILLE DE LA BOTTOM BAR)`,
  },
  EstimationMapButtonDesktop: {
    position: "fixed",
    bottom: `50px`,
    maxWidth: "50vw",
  },
  EstimationTypeButtonDesktop: {
    position: "absolute",
    top: `calc(100vh - 150px)`,
    //marginLeft: '-25vw'
  },
  sideinfo: {
    //marginTop: '-5vh',
    backgroundColor: "#F4F4F4",
    height: typeof window !== "undefined" && window.innerHeight,
    zIndex: "10",
  },

  // ESTIMATION RESULTS
  estimationResultsRightSide: {
    // height: fullVirtualHeight,
    overflow: "visible",

    backgroundColor: "#F4FCFC",
    padding: "20px",
  },

  // ESPACE PRO

  promoteurspaceformControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  // promoteurspaceselectEmpty: {
  //   marginTop: theme.spacing(2)
  // },
  promoteurspacemenuPaper: {
    maxHeight: 100,
  },

  EspaceProTitleToolbar: {
    backgroundColor: "white",
    textAlign: "center",
  },
  originalFont: {
    fontFamily: "Poppins !important",
    letterSpacing: "-1px",
    color: "#3a3a3a",
    display: "inline",
    fontSize: "0.9rem",
    lineHeight: "1.6rem",
    verticalAlign: "middle",
    wordBreak: "break-word",
    // color: black;
    // display: inline;
    // font-family: "Poppins", sans-serif;
    // font-size: 0.9rem;
    // line-height: 1.6rem;
    // vertical-align: middle;
    // word-break: break-word;
  },
  FilterRootContainer: {
    height: `calc(100vh  - 64px - 60px)`,
    padding: "20px",
    overflow: "scroll",
    paddingBottom: "100px",
    overflowX: "hidden",
  },
  FilterRootContainerMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px)`,
    padding: "20px",
    overflow: "scroll",
    width: "100vw",
    zIndex: "100",
    paddingBottom: "100px",
    position: "absolute",
    backgroundColor: "white",
    left: "0",
    top: "60px",
  },
  FiltreButtonContainerTopPage: {
    height: "40px",
    marginBottom: "10px",
    textAlign: "center",
  },
  BottomFilterBar: {
    height: "60px",
    zIndex: "2",
  },
  BottomFilterBarRootContainer: {
    width: "calc(100vw - 300px)",
    right: "0",
    position: "absolute",
    height: "100%",
  },
  BottomFilterBarRootContainerMobile: {
    right: "0",
    position: "absolute",
    height: "100%",
  },
  ProjetPageContainer: {
    padding: "10px",
    // backgroundColor: "#b3b3b340",
  },
  ProjetPageContainerFilterPageOpened: {
    height: `calc(100vh  - 64px - 60px)`,
    width: "calc(100vw - 300px) !important",
    // Same height as FilterRootContainer,
    overflow: "hidden",
    position: "fixed",
    padding: "0 !important",
    zIndex: "2",
  },
  ProjetPageContainerFilterPageOpenedMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 0px - 60px)`,
    // Same height as FilterRootContainer,
    overflow: "hidden",
    paddingBottom: "20px",
  },
  proMenuElements: {
    padding: "5px",
    borderStyle: "solid",
    borderLeftWidth: "0px",
    borderRightWidth: "0px",
    borderTopWidth: "0px",
    borderBottomWidth: "1px",
  },
  projetsDetectesContainerDialog: {
    padding: "40px",
  },
  projetsDetectesContainer: {
    padding: "20px",
  },
  projetsDetectesContainer2: {
    paddingLeft: "20px",
    paddingBottom: "20px",
  },
  maVitrine: {
    padding: "25px",
  },

  //TRANSACTION
  transactionFormContainer: {
    backgroundColor: "white",
    padding: "20px",
  },
  transactionMapContainer: {
    height: "calc(100vh - 60px - 72px - 108px)",
  },
  transactionMapContainerMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 200px - 60px)`,
  },

  TransactionMapOnlyContainerMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 200px - 60px)`,
  },
  TransactionMapOnlyContainer: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 75px - 60px)`,
  },
  HeaderWithBackgroundForm: {
    maxWidth: "75rem",
    margin: "auto",
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "4px 4px 4px 4px",
    overflow: "hidden",
    paddingTop: "30px",
    paddingBottom: "30px",
    float: "left",
    backgroundSize: "cover",
    backgroundPosition: "50%",
    position: "relative",
    zIndex: "2",
    minHeight: "1px",
    boxShadow: "0 9px 23px 1px hsl(0deg 0% 50% / 59%)",
  },
  OffresProPageContainer: {
    top: "80px",
    position: "relative",
  },
  OffresProPageContainerMobile: {
    top: "60px",
    position: "relative",
  },
  AchatPageContainer: {
    top: "80px",
    position: "relative",
    height: `cacl(100vh - 80px)`,
    overflow: "hidden",
  },
  AchatPageContainerMobile: {
    top: "60px",
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px)`,
    overflow: "scroll",
    position: "relative",
  },

  SearchAgencePageContainer: {
    top: "80px",
    position: "relative",
    height: `cacl(100vh - 80px)`,
    overflow: "hidden",
    width: "100% !important",
    maxWidth: "100% !important",
  },
  SearchAgencePageContainerMobile: {
    top: "60px",
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px)`,
    overflow: "scroll",
    position: "relative",
    width: "100% !important",
    maxWidth: "100% !important",
  },
  AchatPageContainerMobileScroll: {
    top: "0px !important",
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px)`,
    overflow: "scroll",
    position: "relative",
  },
  displayAnnoncesContainerMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px - 40px)`,
    overflow: "scroll",
    position: "relative",
  },
  AnnoncesCardDialog: {
    width: "80vw",
    marginLeft: `10vw`,
  },
  // ProjetCardDialog: {
  //   // width: "80vw",
  //   // marginLeft: `10vw`,
  // },

  displayAnnoncesContainerMobileScrolling: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 40px)`,
    overflow: "scroll",
    position: "relative",
  },

  PacksProPageContainer: {
    top: "80px",
    position: "relative",
  },
  PacksProPageContainerMobile: {
    top: "60px",
    position: "relative",
  },

  EstimationProPageContainer: {
    position: "relative",
    // top: "80px",
  },
  EstimationProPageContainerMobile: {
    position: "relative",
    top: "60px",
  },

  PubliUneAnnoncePagecontainer: {
    position: "relative",
    top: "80px",
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 80px - 60px)`,
    overflow: "scroll",
    overflowX: "hidden",
    // paddingBottom: "20px",
  },
  PubliUneAnnoncePagecontainerMobile: {
    position: "relative",
    top: "60px",
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px - 60px)`,
    overflow: "scroll",
    overflowX: "hidden",
    // paddingBottom: "30px",
  },

  // offre pro
  caddreStyle: {
    backgroundColor: "#F4F4F4",
    borderStyle: "solid",
    borderRadius: "25px",
    borderColor: "transparent",
    textAlign: "center",
  },

  //Annonce
  AnnoncePageContainer: {
    position: "relative",
    backgroundColor: "#f2f3f4",
    height: "100vh",
    overflow: "hidden",
  },
  AnnoncePageContainerMobile: {
    position: "relative",
    backgroundColor: "#f2f3f4",
  },

  // Account

  CompteMenuBackground: {
    backgroundColor: "lightgrey",
  },

  //General :

  GridJustifyCenterVertical: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  OutlinedInputSelectComponent: {
    height: "30px !important",
    paddingTop: "1px !important",
    paddingBottom: "1px !important",
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "center !important",
    fontSize: "14px !important",
  },
  ListItemFilter: {
    fontSize: "14px !important",
    paddingTop: "1px",
    paddingBottom: "1px",
  },
  ListItemSelected: {
    backgroundColor: "#edf4fb",
  },
  //Map search
  MapSearchAnnonceMobileContainer: {
    position: "relative",
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px - 80px)`,
    overflow: "hidden",
  },
  MapSearchAnnonceMobileContainerScrolling: {
    position: "relative",
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 40px)`,
    overflow: "hidden",
  },
  SearchFormAnnonceMobileContainer: {
    height: `60px`,
  },
  BottomBarAnnoncesContainer: {
    height: "45px",
    position: "fixed",
    width: `calc(${typeof window !== "undefined" && window.innerWidth
      }px - 40vw)`,
    paddingLeft: "20vw",
    paddingRight: "20vw",
    // top: `calc(${typeof window !== "undefined" && window.innerHeight}px - 180px)`,
    bottom: "25px", //return to 25px after removing pagination
    zIndex: 4,
    alignItems: "center",
    justifyContent: "center",
    transition: "bottom .5s",
    lineHeight: "50px",
    // boxShadow: "0 0 7px 1px rgb(0 0 0 / 25%)",
    // position: "fixed",
  },
  BottomBarAnnoncesContainerAnnonceUp: {
    height: "45px",
    position: "fixed",
    width: `calc(${typeof window !== "undefined" && window.innerWidth
      }px - 40vw) !important`,
    left: "20vw",
    // top: `calc(${typeof window !== "undefined" && window.innerHeight}px - 180px)`,
    bottom: "145px", //return to 25px after removing pagination
    zIndex: 4,
    alignItems: "center",
    justifyContent: "center",
    transition: "bottom .5s",
    lineHeight: "50px",
    boxShadow: "0 0 7px 1px rgb(0 0 0 / 25%)",
    // position: "fixed",
  },
  BottomBarAnnoncesContainerScrolling: {
    height: "45px",
    position: "fixed",
    width: `calc(${typeof window !== "undefined" && window.innerWidth
      }px - 40vw)`,
    left: "20vw",
    // top: `calc(${typeof window !== "undefined" && window.innerHeight}px - 120px)`,
    bottom: "25px", //return to 25px after removing pagination
    zIndex: 4,
    alignItems: "center",
    justifyContent: "center",
    transition: "bottom .5s",
    boxShadow: "0 0 7px 1px rgb(0 0 0 / 25%)",
    // position: "fixed",
  },
  // BottomBarProjetDetectesContainer: {
  //   height: "30px",
  //   position: "fixed",
  //   width: `calc(${typeof window !== "undefined" && window.innerWidth}px - 40vw)`,
  //   left: "20vw",
  //   top: `calc(${typeof window !== "undefined" && window.innerHeight}px - 100px)`,
  //   zIndex: 4,
  //   alignItems: "center",
  //   justifyContent: "center",
  //   transition: "bottom .5s",
  //   boxShadow: "0 0 7px 1px rgb(0 0 0 / 25%)",
  //   // position: "fixed",
  // },

  // BottomBarProjetDetectesContainerScrolling: {
  //   height: "45px",
  //   position: "fixed",
  //   width: `calc(${typeof window !== "undefined" && window.innerWidth}px - 40vw)`,
  //   left: "20vw",
  //   top: `calc(${typeof window !== "undefined" && window.innerHeight}px - 120px)`,
  //   zIndex: 4,
  //   alignItems: "center",
  //   justifyContent: "center",
  //   transition: "bottom .5s",
  //   lineHeight: "50px",
  //   boxShadow: "0 0 7px 1px rgb(0 0 0 / 25%)",
  //   // position: "fixed",
  // },

  FiltreButtonContainerTopPageProjects: {
    height: "30px",
    textAlign: "center",
  },
  DisplayAnnonceDesktopContainer: {
    height: "calc(100vh - 80px - 60px)",
    overflow: "scroll",
    boxShadow: "-2px 2px 5px 0 #585858a1",
    zIndex: 1,
    overflowX: "hidden",
  },
  DisplayFavorisContainer: {
    // height: "calc(100vh - 80px - 60px)",
    // overflow: "scroll",
    // boxShadow: "-2px 2px 5px 0 #585858a1",
    zIndex: 1,
    overflowX: "hidden",
  },
  MapAnnonceDesktopContainer: {
    height: "calc(100vh - 80px - 60px)",
    overflow: "hidden",
  },
  CardAnnonceContentMobile: {
    padding: "0 !important",
  },
  CardAnnonceContent: {
    borderRadius: "0 !important",
    borderBottom: "2px solid #40a1f8",
    padding: "0 !important",
  },
  CarteAnnonceMobileContainer: {
    borderRadius: "0 !important",
    borderBottom: "4px solid #40a1f8",
  },
  CarteAnnonceContainer: {
    borderRadius: "0 !important",
    borderBottom: "2px solid #40a1f8",
  },
  filtrePrixItem: {
    paddingLeft: "10px",
    paddingRight: "10px",
  },

  SignUpPageImageContainer: {
    height: "calc(100vh - 80px)",
    overflow: "hidden",
  },
  SignUpPageFormContainer: {
    height: "calc(100vh - 80px)",
    overflow: "scroll",
    overflowX: "hidden",
  },
  PaperSearchMobile: {
    left: "0 !important",
    width: "100vw",
    maxWidth: "100vw !important",
  },

  PaperSearchFormDesktop: {
    // left : '0 !important',
    // width : '100vw',
    // maxWidth : '100vw !important',
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingBottom: "20px",
  },
  PaperSearchFormDesktop2: {
    paddingLeft: "25px",
  },

  ListSearchPrixMobile: {
    paddingBottom: "0 !important",
  },
  OutlinedInputSelectComponentMobileSearch: {
    paddingTop: "5px !important",
    paddingBottom: "5px !important",
    // borderRadius: "10px",
  },
  fullHeightMobileSearchBarAnnonce: {
    height: "40px",
  },
  AutoCompleteTextFieldFocused: {
    // top : '0 !important'
  },
  AutoCompleteTextFieldRoot: {
    // top : '-12px'
  },
  MobileSearchComponent: {
    height: "60px",
    paddingLeft: "10px",
    paddingTop: "15px",
    borderBottom: "1px solid #8080806e",
  },
  MapPublierUneAnnonceContainer: {
    height: "calc(100vh - 60px - 80px)",
    overflow: "hidden",
  },
  MapPublierUneAnnonceContainerMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px - 60px - 212px)`,
    overflow: "hidden",
  },
  MapLocaliserMonAgence: {
    height: "calc(100vh - 60px - 280px)",
    overflow: "hidden",
  },
  MapLocaliserMonAgenceMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px - 60px - 212px)`,
    overflow: "hidden",
  },
  CarouselObtenirLePrixContainer: {
    height: "20vh",
  },
  CarouselObtenirLePrixContainerMobile: {
    height: "20vh",
  },
  AnnonceDialogTopBarContainer: {
    height: "60px",
    backgroundColor: "white",
  },

  AnnonceDialogTopBarContainerMobile: {
    height: "50px",
    backgroundColor: "white",
  },
  AnnoncesCardDialogPaper: {
    marginTop: "0px !important",
    marginBottom: "0px !important",
    maxHeight: "100vh !important",
  },
  ProjetCardDialogPaper: {
    marginTop: "0px !important",
    marginBottom: "0px !important",
    // maxHeight: "100vh !important",
  },
  DialogAnnonceImagesContainer: {
    height: `calc(100vh - 60px)`,
    overflow: "scroll",
  },
  DialogAnnonceAllContainerMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px - 50px)`,
    overflow: "scroll",
  },

  DialogAnnonceContactAndDetailsContainer: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px)`,
    overflow: "scroll",
  },
  DialogAnnonceContactAndDetailsContainerMobile: {
    height: `calc(${typeof window !== "undefined" && window.innerHeight
      }px - 60px)`,
    overflow: "scroll",
  },
  PrixSearchDropDownPaper: {
    maxWidth: "450px",
  },

  // SQUELETONS

  squeletonRoot: {
    height: "15px",
    borderRadius: "50px",
  },
  colorPrimary: {
    backgroundColor: "#80808026",
  },
  barColorPrimary: {
    backgroundColor: "#e2e2e266",
  },

  // PROJET NEUF

  addProjetNeufcontainer: {
    width: `calc(100vw - 300px)`,
  },

  // OBTENIR LE PRIX

  paperWidthSm: {
    maxWidth: "90vw",
    width: "90vw",
    height: "90vh",
    backgroundColor: "#f2f3f4",
  },
});

export default styles;
